import Typography from '@material-ui/core/Typography'
import {useEvent} from 'Event/EventProvider'
import TextField from 'lib/ui/TextField'
import {api} from 'lib/url'
import Page from 'organization/Event/Page'
import {useServices} from 'organization/Event/Services/ServicesProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import React, {useState} from 'react'
import {useForm} from 'react-hook-form'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import styled from 'styled-components'
import {Button} from '@material-ui/core'
import {ConvertKitIntegration} from 'organization/Event/Services/Apps/ConvertKit'

export interface ConvertKitAuth {
  api_key: string
  api_secret: string
}

export default function LinkPage() {
  const {handleSubmit, register} = useForm()
  const auth = useAuthConvertKit()
  const [processing, setProcessing] = useState(false)
  const {add: addIntegration} = useServices()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const submit = (data: ConvertKitAuth) => {
    if (processing) {
      return
    }

    setErrorMessage(null)
    setProcessing(true)

    auth(data)
      .then(addIntegration)
      .catch((e) => {
        setErrorMessage(e.message)
      })
      .finally(() => setProcessing(false))
  }

  return (
    <Page>
      <Typography variant="h4">Convert Kit</Typography>
      <p>
        To obtain your Convert Kit API Key and Secret, follow these steps in
        your Convert Kit account:
      </p>
      <p>
        1. <b>Click "Settings"</b> (gear icon) on the right menu.
      </p>
      <p>
        2. The Account Settings menu will appear.{' '}
        <b>Click the "Advanced" option.</b>
      </p>
      <p>
        3. <b>Copy your API Key and Secret</b> and{' '}
        <b>paste it into the fields below.</b>
      </p>

      <br />
      <form onSubmit={handleSubmit(submit)}>
        <TextField
          label="API Key"
          name="api_key"
          fullWidth
          variant="outlined"
          inputProps={{ref: register, 'aria-label': 'api key'}}
          disabled={processing}
        />
        <TextField
          label="API Secret"
          name="api_secret"
          fullWidth
          variant="outlined"
          inputProps={{ref: register, 'aria-label': 'api secret'}}
          disabled={processing}
        />
        <Button
          color="primary"
          variant="contained"
          aria-label="authorize"
          type="submit"
          disabled={processing}
        >
          Authorize
        </Button>
        <StyledErrorAlert>{errorMessage}</StyledErrorAlert>
      </form>
    </Page>
  )
}

const StyledErrorAlert = styled(ErrorAlert)`
  width: 100%;
  margin-top: ${(props) => props.theme.spacing[4]};
`

function useAuthConvertKit() {
  const {client} = useOrganization()
  const {event} = useEvent()

  return (authData: ConvertKitAuth) => {
    return client.post<ConvertKitIntegration>(
      api(`/events/${event.id}/integrations/convert_kit/link`),
      {...authData},
    )
  }
}
